<template>
    <div class="interviewList">
        <div class="tableCont">
            <div class="tabCont">
                <el-tabs
                    v-model="searchForm.status"
                    type="border-card"
                    @tab-click="interview"
                    ref="tabs"
                >
                    <el-tab-pane
                        v-for="item in statusList"
                        :key="item.status"
                        :name="item.status"
                    >
                        <span slot="label" class="label"
                            ><!-- <i class="el-icon-box"></i> -->{{
                                item.name
                            }}
                            {{ item.total }}</span
                        >
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                        @keydown.enter.native="interview"
                    >
                        <el-form-item label="应聘者姓名" size="small">
                            <el-input
                                clearable
                                placeholder="请输入应聘者姓名"
                                size="small"
                                v-model="searchForm.name"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="应聘者手机号" size="small">
                            <el-input
                                clearable
                                placeholder="请输入应聘者手机号"
                                size="small"
                                v-model.number="searchForm.phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="应聘者邮箱" size="small">
                            <el-input
                                clearable
                                placeholder="请输入应聘者邮箱"
                                size="small"
                                v-model="searchForm.email"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                            >
                                重置条件
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="interview(1)"
                    >
                        查询
                    </el-button>
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                        @keydown.enter.native="interview"
                    >
                        <el-form-item label="应聘者姓名" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入应聘者姓名"
                                size="mini"
                                v-model="searchForm.name"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="应聘者手机号" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入应聘者手机号"
                                size="mini"
                                v-model.number="searchForm.phone"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="应聘者邮箱" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入应聘者邮箱"
                                size="mini"
                                v-model="searchForm.email"
                            >
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="interview(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth.slice(0, 2)">
                            <el-button
                                type="primary"
                                :key="item.id"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                        <el-dropdown
                            v-if="menuAuth.length > 2"
                            @command="authFunc"
                            style="margin-left: 10px"
                        >
                            <el-button
                                type="primary"
                                size="mini"
                                icon="el-icon-arrow-down"
                            >
                                更多操作
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    :key="item.id"
                                    v-for="item in menuAuth.slice(2)"
                                    :command="item.funcName"
                                >
                                    <i :class="item.icon"> </i>
                                    {{ item.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div v-else></div>
                </div>
                <!-- 高级搜索 -->
                <advancedSearch :drawerVisible.sync="drawerVisible"
                    >高级搜索</advancedSearch
                >
            </div>

            <div class="table" :style="{ height: $store.state.index.screen }">
                <el-table
                    :data="tableData"
                    ref="tableData"
                    highlight-current-row
                    height="100%"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        align="left"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="面试岗位"
                        property="recruitment_position"
                        align="left"
                        min-width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="应聘者姓名"
                        property="name"
                        align="left"
                        width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="应聘者手机号"
                        property="phone"
                        align="left"
                        min-width="110"
                    ></el-table-column>
                    <el-table-column
                        label="应聘者邮箱"
                        property="email"
                        align="left"
                        min-width="140"
                    ></el-table-column>
                    <el-table-column
                        label="面试官"
                        property="interviewer_name"
                        align="left"
                        width="90"
                    ></el-table-column>
                    <el-table-column
                        label="面试时间"
                        property="interview_time"
                        align="left"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        label="签到时间"
                        property="checkin_time"
                        align="left"
                        width="140"
                    ></el-table-column>
                    <el-table-column
                        label="面试总结"
                        align="left"
                        min-width="140"
                    >
                        <template slot-scope="scope">
                            <el-popover
                                placement="bottom"
                                width="200"
                                trigger="click"
                                :content="scope.row.conclusion"
                                v-if="scope.row.conclusion.length > 10"
                            >
                                <p slot="reference">
                                    {{ scope.row.conclusion | ellipsis }}
                                </p>
                            </el-popover>
                            <p v-else>
                                {{ scope.row.conclusion | ellipsis }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="当前状态" align="left" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == 1
                                        ? 'info'
                                        : scope.row.status == 2 ||
                                          scope.row.status == 5
                                        ? 'success'
                                        : scope.row.status == 10 ||
                                          scope.row.status == 15
                                        ? 'danger'
                                        : 'warning'
                                "
                            >
                                {{ scope.row.status_cn }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        width="80"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="创建时间"
                        width="140"
                        property="create_time"
                        align="left"
                    ></el-table-column>
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                        >{{ item.name }}</el-button
                                    >
                                    <popConfirm
                                        v-else
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="rowDo(scope.row, item)"
                                    >
                                    </popConfirm>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>

            <importPublic
                :importVisible.sync="importVisible"
                :parentFuncName="'interview'"
                :methodName="'interviewBatchImport'"
                :temSrc="'/v1/interview/download-tpl'"
                :title="'面试信息导入'"
            ></importPublic>
        </div>
        <interviewAdd :addVisible.sync="addVisible"></interviewAdd>
        <interviewEdit
            :editVisible.sync="editVisible"
            :tableItem="tableItem"
            :special="special"
        ></interviewEdit>
        <interviewDetail
            :detailVisible.sync="detailVisible"
            :tableItem="tableItem"
        ></interviewDetail>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";

import pagination from "@/comon/components/pagination";
import importPublic from "@/comon/components/importPublic";
import advancedSearch from "@/comon/components/advancedSearch";
import popConfirm from "@/comon/components/popConfirm";

export default {
    mixins: [tableMixin],

    data() {
        return {
            searchForm: {
                name: "",
                phone: "",
                status: "0",
                email: "",
            },
            menuId: "",
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },

            tableItem: [],
            detailVisible: false,
            addVisible: false,

            selectionUserIdList: [],

            drawerVisible: false,
            editVisible: false,
            statusList: [],
            importVisible: false,
            special: false,
        };
    },
    methods: {
        detail(row) {
            //console.log(row);
            this.tableItem = row;
            this.detailVisible = true;
        },
        add() {
            this.addVisible = true;
        },
        clean() {
            this.searchForm = {
                name: "",
                phone: "",
                status: "0",
                email: "",
            };
            this.interview();
        },
        export() {
            oaApi.interviewBatchExport().then((res) => {
                if (res) {
                    window.open(res.data.url);
                }
            });
        },
        /**
         * 批量删除
         */
        batchDel() {
            if (this.selectionUserIdList.length > 0) {
                this.$confirm("是否批量删除选中的数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        oaApi
                            .eventsBatchDelete({
                                ids: this.selectionUserIdList.toString(),
                            })
                            .then((res) => {
                                //console.log(res);
                                if (res.code == 200) {
                                    this.$message.success("删除成功！");
                                    this.interview();
                                } else {
                                    this.$message.error("删除失败！");
                                }
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } else {
                this.$message.warning("请勾选要删除的数据");
            }
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取面试列表
         */
        interview(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .interview(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        /* this.$nextTick(() => {
                            this.resetTabActivePosition(this.$refs.tabs.$el);
                        }); */
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.$refs.tableData.bodyWrapper.scrollTop = 0;
                        this.closeDrawer();
                    }
                });
        },

        resetTabActivePosition($el) {
            var activeEl = $el.querySelector(".el-tabs__item.is-active");
            //console.log(activeEl);
            var lineEl = $el.querySelector(".el-tabs__active-bar");
            if (activeEl) {
                var style = getComputedStyle(activeEl);
                var pl = style.paddingLeft.match(/\d+/)[0] * 1;
                var pr = style.paddingRight.match(/\d+/)[0] * 1;
                var w = style.width.match(/\d+/)[0] * 1;
                lineEl.style.transform =
                    "translateX(" + (activeEl.offsetLeft + pl) + "px)";
                lineEl.style.width = w - pl - pr + "px";
            }
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.interview();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "查看") {
                this.detail(row);
            } else if (item.name == "编辑") {
                this.edit(row);
                this.special = false;
            } else if (item.name == "删除") {
                /* this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => */
                oaApi.interview({}, "delete", row.id).then((res) => {
                    if (res) {
                        if (res.code == 200) {
                            this.$message.success(`${item.name}成功`);
                            this.interview();
                        }
                    }
                });
                /* )
                    .catch(() => {
                        this.$message.info("已取消操作");
                    }); */
            } else if (item.name == "总结") {
                this.edit(row);
                this.special = true;
            } else if (item.name == "缺席") {
                /* this.$confirm(`确定${item.name}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => { */
                let params = {
                    id: row.id,
                    status: 15,
                };
                oaApi.interviewUpdateStatus(params, "post").then((res) => {
                    if (res) {
                        this.$message.success(`${item.name}成功`);
                        this.interview();
                    }
                });
                /* })
                    .catch(() => {
                        this.$message.info("已取消操作");
                    }); */
            }
        },
        edit(row) {
            this.tableItem = row;
            this.editVisible = true;
        },
        bulkImport() {
            this.importVisible = true;
        },
        authFunc(funcName) {
            this[funcName]();
        },
        handleSelectionChange(val) {
            this.selectionUserIdList = [];
            for (let i in val) {
                this.selectionUserIdList.push(val[i].id);
            }
        },
    },
    created() {
        this.interview();
    },
    components: {
        pagination: pagination,
        importPublic: importPublic,
        advancedSearch: advancedSearch,
        popConfirm: popConfirm,
        interviewAdd: () => import("./interviewList/add"),
        interviewEdit: () => import("./interviewList/edit"),
        interviewDetail: () => import("./interviewList/detail"),
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.interview();
            },
            deep: true,
            immediate: false,
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.interview();
            },
            deep: true,
            immediate: false,
        },
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
    },
};
</script>
<style lang="scss">
.interviewList {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .tableCont {
        // width: calc(100% - 250px);
        width: 100%;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            // padding: 0 20px;
            // .el-scrollbar__wrap {
            //     overflow-x: hidden;
            // }
            .nameCont {
                display: flex;
                align-items: center;
                justify-content: center;
                .headImg {
                    height: 16px;
                    width: 16px;
                    border-radius: 8px;
                    overflow: hidden;
                    margin-right: 8px;
                }
                .memberName {
                    line-height: 24px;
                }
            }
        }
    }
    // .el-scrollbar__wrap {
    //     overflow-x: hidden;
    // }
}
</style>
